import { postGenerateLinkAsync } from 'API/order/documents/DocumentsAPI';
import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';

export const { slice: postGenerateLinkSlice, asyncAction: postGenerateLinkAction } = createAsyncSliceWithDataAndQuery(
  'generateLink',
  postGenerateLinkAsync,
  {
    id: '',
    createdAt: '',
    createdBy: '',
    downloadUrl: '',
    expired: false,
    expiredManuallyAt: '',
    expiredManuallyBy: '',
    expiresAt: '',
  }
);
